const riot = require('riot');

riot.tag2('page-bio', '<div class="relative"> <div data-is="module-bg-image"></div> <div class="relative s-full f fh container mb64 s-pr16"> <div class="s-full overflow-scroll px64 s-pr0"> <h1 class="text-center s-text-right mb8 pt64 s-pt32 fs32">BIO</h1> <h2 class="text-center s-text-right mb16 s-mrn8">- 2019〜2024 -</h2> <div class="row s-flex-wrap-reverse flex-between pt64 mb32"> <div class="col6 s-col12 f flex-column fh pr16 s-pr0 s-mb16" data-reveal-class="fadein-bottom"> <h2 class="fs32 s-fs24 text-left mb64 s-mb32">上野容 - YOH</h2> <p class="word-break-all white-space-pre-wrap lh16 text-softgray">{profile}</p> </div> <div class="col6 s-col12 flex-fixed opacity-0 s-mb16" data-reveal-class="fadein-bottom-text"><img class="s-full object-fit-cover" src="/images/bios/bio_top.JPG"></div> </div> <div class="mb64 s-mb32" each="{items, index in bio}"> <div data-is="module-bio" bio="{items}" index="{index}"></div> </div> </div> </div> <div data-is="module-footer"></div> <div class="fixed t0 l0 b0" data-is="module-sidebar"></div> </div>', '', '', function(opts) {
    this.profile = `　東京出身のダンスアーティスト。出演、振付、レッスンなどを軸に、声優/ナレーターやモデルなど多方面で活動中。\n\n　ジャズダンスをベースに、様々なジャンルを混ぜた独自のスタイルを特徴とするオールラウンダー。\n　キレの良さとしなやかさ、語るような繊細な表現力を活かし、ダンスを通じて役を演じる機会が多く、数々の舞台やイマーシブシアターに出演。Hagriとのチーム"KEMURI"としても注目を集める。\n\n　自身の舞台やメディア出演以外にも、幅広い世代のアーティストの MV や CM の振付/演出を手がける。振付作品を発表する事にも力を入れており、近年では"YOH-Jirushi"という映像プロジェクトを継続中。\n　都内ダンススタジオや専門学校での講師を務め、地方や海外でのワークショップも精力的に行なう。\n\n　また、幼少期に声優/俳優として活動していた経歴を持ち、代表作は映画『ハリー・ポッター』全シリーズ(ネビル・ロングボト ム役)の日本語吹き替え。\n　多くの舞台、テレビ、映画等に出演した経歴を活かし、現在も『NewsPicks』等ナレーションを中心に 声の出演を続けている。`;

    this.on('show', () => {
      window.requestAnimationFrame(() => {
        app.utils.observeAnimationElement(this.root);
        this.update();
      });
    });

    this.preload = async ({req, res}) => {
      var query = {
        limit: 30
      };
      var bio = await fetch(`${spat.config.cms.APIURL}/bios?orders=updatedAt&limit=150`, {
        headers: {
          "X-API-KEY": spat.config.cms.APIKey,
        },
      },).then(res => res.json()).then(res => {
        return res.contents;
      });

      var kinds = [
        {id: 'mv_or_cm', label: "MV / CM"},
        {id: 'stage_or_backup', label: "舞台 / バックアップ"},
        {id: 'immersive_theater', label: "イマーシブシアター"},
        {id: 'narration', label: "吹替 / ナレーション"},
        {id: 'kemuri', label: "Team"},
        {id: 'history', label: "History"}
      ];

      var items = kinds.map(kind => {
        return {
          title:kind.label,
          kind: kind.id,
          image: `/images/bios/bio_${kind.id}.JPG`,
          items: bio.filter(item => item.category.some(v => v === kind.id)),
        };
      });

      return {
        bio: items,
      };
    };
});